class SubscriptionWidget extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.formId = this.dataset.sectionId ? `product-form-${this.dataset.sectionId}` : null;
    self = this;

    this.addEventListener('change', (event) => {
      const changedInput = event.target;

      if (changedInput.name === 'selling_plan') {
        const selectedIndex = changedInput.dataset.index;
        const selectedValue = changedInput.value;
        const price = changedInput.dataset.price;

        this.toggleVariantSelects(selectedValue);

        if (selectedIndex) {
          const variantInput = document.querySelector(`.product-form__input--pill input[data-index="${selectedIndex}"]`);
          if (variantInput && !variantInput.checked) {
            variantInput.click();
          }
        }

        if (selectedValue === '') return;

        setTimeout(() => {
          this.updateButtonPrice(price);
        }, 2000);
      }
    });

    window.addEventListener('DOMContentLoaded', () => {
      this.updateInitialSubscriptionPrice();
      this.toggleInitialVariantVisibility();
    });
  }

  updateInitialSubscriptionPrice() {
    const checkedInput = this.querySelector('input[name="selling_plan"]:checked');
    if (!checkedInput) return;

    const selectedValue = checkedInput.value;
    const price = checkedInput.dataset.price;

    if (selectedValue === '') return;

    setTimeout(() => {
      this.updateButtonPrice(price);
    }, 500);
  }

  toggleInitialVariantVisibility() {
    const checkedInput = this.querySelector('input[name="selling_plan"]:checked');
    if (checkedInput) {
      this.toggleVariantSelects(checkedInput.value);
    }
  }

  toggleVariantSelects(value) {
    const variantSelect = document.querySelector('variant-selects');
    if (!variantSelect) return;

    if (value === '') {
      self.classList.add('show__options');
    } else {
      self.classList.remove('show__options');
    }
  }

  updateButtonPrice(price) {
    if (!price) return;

    const priceRegular = document.querySelector('.button_price .price__regular .price-item--regular');
    const priceSale = document.querySelector('.button_price .price__sale .price-item--sale');

    if (priceRegular) priceRegular.textContent = price;
    if (priceSale) priceSale.textContent = price;
  }
}

customElements.define('subscription-widget', SubscriptionWidget);